import clsx from "clsx";
import PromoTopAlert from "components/promo/top-alert";
import { PropsWithChildren, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { HorizontalBar } from "./horizontal-bar";
import css from "./index.module.scss";
import { MobileHeader } from "./mobile-header";
import { SidebarInner } from "./sidebar-inner";
import TopAlert from "./top-alert";

export const Layout = ({ children }: PropsWithChildren) => {
  const [sidebarMobileShow, sidebarMobileShowSet] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!sidebarMobileShow) return;
    document.body.classList.add(css.body);
    return () => document.body.classList.remove(css.body);
  }, [sidebarMobileShow]);

  useEffect(() => {
    sidebarMobileShowSet(false);
  }, [pathname]);

  return (
    <div className={css.app}>
      <div className={css.top}>
        <PromoTopAlert />
        <TopAlert />
        <HorizontalBar border className={css.mobileOnly}>
          <MobileHeader onSidebarOpenClick={() => sidebarMobileShowSet(true)} />
        </HorizontalBar>
      </div>
      <div className={css.layout}>
        <div
          className={clsx(
            css.sidebar,
            sidebarMobileShow && css.sidebarMobileShow,
          )}
        >
          <div className={css.mobileOnly}>
            <PromoTopAlert />
            <TopAlert />
          </div>
          <HorizontalBar>
            <MobileHeader
              className={css.mobileOnly}
              onSidebarCloseClick={() => sidebarMobileShowSet(false)}
            />
          </HorizontalBar>
          <SidebarInner />
        </div>
        <div className={css.main}>{children}</div>
      </div>
    </div>
  );
};
